<template>
  <a-modal title="添加原料" :visible="hidden" @ok="ok" :bodyStyle="{ padding: '10px' }" :destroyOnClose="true"
    :forceRender="true" @cancel="cancel" :footer="null" width="900px">
    <a-row style="padding: 0 0 10px" type="flex" align="middle" justify="space-between">
      <a-col>
        <a-input-search size="small" v-model="filterData.name" @change="(e) => inputChange(e, 'name')"
          placeholder="原料名称/代码" style="width: 180px; margin-right: 10px" @search="(e) => onSearch(e, 'name')" />
        <a-input-search v-if="overseasFlag == 1" size="small" v-model="filterData.aliasName"
          @change="(e) => inputChange(e, 'aliasName')" placeholder="原料别名" style="width: 180px"
          @search="(e) => onSearch(e, 'aliasName')" />
      </a-col>
      <a-col>
        <!-- <a-select
          v-model="status"
          placeholder="请选择原料状态"
          @change="getList"
          style="width: 180px; margin-right: 10px"
        >
          <a-select-option :value="0">激活</a-select-option>
          <a-select-option :value="1">失效</a-select-option>
        </a-select> -->
        <base-list-select style="width: 180px" :value="rawType" @change="typeChange" placeholder="选择原料类型"
          category="raw" />
      </a-col>
    </a-row>
    <a-table :columns="columns" bordered :scroll="{ x: 0, y: 450 }"
      :row-selection="{ selectedRowKeys, onSelect, onSelectAll }" :loading="nutLoading" :data-source="list.records"
      :row-key="(record) => record.id" :pagination="pagination" @change="listChange">
      <template slot="name" slot-scope="text, record">
        {{ overseasFlag == "1" ? record.aliasName || text : text }}
      </template>
      <template slot="fixed3" slot-scope="t">{{
        t || t === 0 ? Number(t).toFixed(3) : t
      }}</template>
      <template slot="rawTypeName" slot-scope="text, record, index">
        <a-tooltip @visibleChange="rawTypeNameTipsVisibleChange($event, record, index)">
          <template slot="title">
            {{ record.fullTypeName }}
          </template>
          <span style="cursor: pointer" :style="{ color: record.color }">{{ text }}</span>
        </a-tooltip>
      </template>
      <div slot="status" slot-scope="text, record">
        <span :style="{ color: !text ? 'green' : 'red' }">{{
          !text ? "激活" : "失效"
        }}</span>/{{ record.categoryTypeName ? record.categoryTypeName : "-" }}
      </div>
    </a-table>
    <a-row type="flex" justify="space-between" class="footer">
      <span>
        <span style="font-size: 12px" v-if="selectedRows.length">
          已选中 {{ selectedRows.length }}条原料
        </span>
      </span>
      <a-space>
        <a-button @click="cancel">取消</a-button>
        <a-button @click="ok" type="primary">保存</a-button>
      </a-space>
    </a-row>
  </a-modal>
</template>

<script>
import { nhfMixins } from '../../untils';
import BaseListSelect from '../select/BaseListSelect.vue';
export default {
  components: { BaseListSelect },
  props: ['hidden'],
  mixins: [nhfMixins],
  data() {
    return {
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      nutLoading: false,
      filterData: {},
      list: {},
      showFooter: false,
      status: undefined,
      rawType: [],
      columns: [
        {
          dataIndex: 'name',
          title: '原料名称',
          width: 300,
          scopedSlots: { customRender: 'name' },
        },
        {
          dataIndex: 'code',
          align: 'center',
          title: '代码',
          width: 100,
          scopedSlots: { customRender: 'code' },
        },
        {
          dataIndex: 'rawTypeName',
          title: '类型',
          width: 120,
          scopedSlots: { customRender: 'rawTypeName' },
        },
        {
          dataIndex: 'storageWeight',
          title: '库存量',
          width: 110,
          scopedSlots: { customRender: 'fixed3' },
          align: 'center',
        },
        {
          dataIndex: 'unit',
          title: '单位',
          width: 80,
          align: 'center',
        },
        {
          title: '状态/类目归属',
          dataIndex: 'status',
          width: 120,
          scopedSlots: { customRender: 'status' }
        },
      ]
    };
  },
  mounted() {
    // this.getList(this.pagination)
  },
  watch: {
    hidden(val) {
      let { current = 1, pageSize = 100 } = this.pagination || {};
      val ? this.getList({ current, size: pageSize }) : this.restList();
    }
  },
  methods: {
    inputChange({ target }, feild) {
      let { current = 1, pageSize = 100 } = this.pagination || {};
      this.getList({ [feild]: target.value, current, size: pageSize });
    },

    ok() {
      if (this.selectedRows.length) {
        this.$emit('ok', this.selectedRows);
        this.cleanSelect();
      } else {
        this.$message.warn('选择需要添加的原料');
      }
    },

    cancel() {
      this.$emit('cancel');
    },

    getList(arg = {}) {
      return this.fetchGet({
        showMessage: false,
        actions: this.myRawpage,
        isList: true,
        name: 'list',
        loading: 'nutLoading',
        data: {
          ...this.filterData,
          factoryId: this.factoryId,
          formulaId: this.formulaId,
          ...arg,
          // size:2000,
          status: this.status,
        }
      });
    },

    onSearch(name, feild) {
      let { current = 1, pageSize = 100 } = this.pagination || {};
      this.getList({ [feild]: name, current, size: pageSize });
    },

    typeChange(val) {
      this.rawType = val;
      const typeId = [...val].pop();
      this.filterData.typeId = typeId;
      let { current = 1, pageSize = 100 } = this.pagination || {};
      this.getList({ typeId, current, size: pageSize });
    },
    restList() {
      this.rawType = [];
      this.filterData = {};
      this.cleanSelect();
    },
    listChange(page) {
      this.getList({ ...this.tablePageChange(page), ...this.filterData });
    },
    rawTypeNameTipsVisibleChange(show, item) {
      item.color = show ? '#1677FF' : '';
      this.$forceUpdate();
    },
  }
};
</script>
<style lang="scss" scoped>
.footer {
  padding: 10px 15px 0;
  margin: 10px -10px 0;
  border-top: 1px solid #eee;
}
</style>
